// Super Admin shared helpers

export const STATUS_STYLES = {
  active:    { label: 'Active',    cls: 'bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200' },
  trial:     { label: 'Trial',     cls: 'bg-sky-50 text-sky-700 ring-1 ring-sky-200' },
  suspended: { label: 'Suspended', cls: 'bg-red-50 text-red-700 ring-1 ring-red-200' },
  expired:   { label: 'Expired',   cls: 'bg-amber-50 text-amber-700 ring-1 ring-amber-200' },
};

export function formatINR(n) {
  return '₹' + Number(n || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 });
}

export function formatDate(ymd) {
  if (!ymd) return '—';
  const [y, m, d] = String(ymd).slice(0, 10).split('-');
  return `${d}-${m}-${y}`;
}

export function daysLabel(days) {
  if (days == null) return 'No expiry';
  if (days < 0) return `Expired ${Math.abs(days)}d ago`;
  if (days === 0) return 'Expires today';
  return `${days} days left`;
}

export const errMsg = (err, fallback = 'Something went wrong') => err?.response?.data?.message || fallback;
